import { useMemo, useState } from "react";

import HintModal from "../common/hint-modal";
import TabsClient from "../../../Components/new-client-dashboard/Tabs";
import AddIcon from "../../../assets/Add-icon-gold.svg";

import FirmUserSignaturesTab from "./FirmUserSignaturesTab";
import EditSignatureModal from "./EditSignatureModal";
import useEmailSignature, {
  useDeleteEmailSign,
  useEditEmailSign,
  useSaveEmailSign,
} from "./hooks/useEmailSignature";

const EmailSignature = () => {
  const points = [
    "Design email signatures for all firm users with customizable logos and contact information",
    "Choose between firm main logo, printing logo, or no logo for all signatures",
    "Use firm user's home address or customize contact details individually",
  ];

  const [showHints, setShowHints] = useState(false);
  const [activeTab, setActiveTab] = useState("firm_user_signatures");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedSignature, setSelectedSignature] = useState(null);
  const { saveEmail } = useSaveEmailSign();
  const { editEmailSign } = useEditEmailSign();
  const { deleteEmailSign } = useDeleteEmailSign();

  const { data, refetch } = useEmailSignature();
  const handleHintToggle = () => {
    setShowHints(!showHints);
  };

  const handleTabChange = (id) => {
    setActiveTab(id);
  };

  const handleEditSignature = (signature) => {
    setSelectedSignature(signature);
    setEditModalOpen(true);
  };

  const handleSaveSignature = async (updatedSignature) => {
    if (updatedSignature?.id) {
      await editEmailSign(updatedSignature);
      await refetch();
    } else {
      await saveEmail(updatedSignature);
      await refetch();
    }
  };

  const handleDeleteSignature = async (updatedSignature) => {
    await deleteEmailSign(updatedSignature);
    await refetch();
  };

  const mainTabs = useMemo(
    () => [
      {
        id: "firm_user_signatures",
        label: "Email Signatures",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        onClick: () => handleTabChange("firm_user_signatures"),
        leftHand: false,
      },
    ],
    []
  );

  const actionTabs = useMemo(
    () => [
      {
        id: "edit_signatures",
        label: "Edit Email Signatures",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        onClick: () => {
          setSelectedSignature(null); // Open for generating all signatures
          setEditModalOpen(true);
        },
        leftHand: true,
        span: (
          <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
            <img className="d-flex align-items-center justify-content-center" src={AddIcon} />
          </span>
        ),
      },
    ],
    []
  );

  const renderActiveTabContent = () => {
    switch (activeTab) {
      case "firm_user_signatures":
        return (
          <FirmUserSignaturesTab signaturesData={data} onEditSignature={handleEditSignature} />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="tab-pane fade firm-settings-user-perms-fs active show">
        <div className="d-flex">
          <div
            className=""
            style={{
              width: "50%",
            }}
          >
            <TabsClient
              currentTab={activeTab}
              tabsData={mainTabs}
              height={25}
              labelClass=" justify-content-start"
            />
          </div>
          <div
            className=""
            style={{
              width: "50%",
            }}
          >
            <TabsClient
              currentTab={activeTab}
              tabsData={actionTabs}
              height={25}
              labelClass="ps-2 justify-content-start"
            />
          </div>
          <div
            className="d-flex justify-content-end"
            onClick={() => {
              handleHintToggle();
            }}
          >
            <i className="ic ic-19 ic-help-2 cursor-pointer" />
          </div>
        </div>
        <div className="tab-content new-lead-sources-tab">{renderActiveTabContent()}</div>
      </div>

      {editModalOpen && (
        <EditSignatureModal
          show={editModalOpen}
          handleClose={() => setEditModalOpen(false)}
          signatureData={selectedSignature}
          onSave={handleSaveSignature}
          onDelete={handleDeleteSignature}
        />
      )}

      {showHints && <HintModal show={showHints} handleClose={handleHintToggle} points={points} />}
    </>
  );
};

export default EmailSignature;
